import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { WithdrawalOverviewModel } from '../../Models/Models/Payments/Withdrawals/WithdrawalOverviewModel';

declare var IS_RUNNING_IN_APP_POOL;

export class WithdrawalsOverviewClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<WithdrawalOverviewModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/WithdrawalsOverview/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<WithdrawalOverviewModel, any>(url, data);
  }
}

